"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteEdit = exports.setModifyProject = exports.modifyProjectFailure = exports.modifyProjectRequest = exports.saveStepSuccess = exports.saveStepFailure = exports.saveStep = exports.clearBillingInformationModal = exports.setBillingInformations = exports.selectBillingInformationProject = exports.selectBillingInformationCustomer = exports.searchBillingInformationSuccess = exports.searchBillingInformationFailed = exports.searchBillingInformationRequest = exports.fetchPrintProviderFailure = exports.toggleEditBillingInformationModal = exports.removeBillingInformationCustomer = exports.toggleBillingInformationModal = exports.fetchPrintProviderSuccess = exports.fetchPrintProviderRequest = exports.createProjectFailed = exports.createProjectSuccess = exports.createProject = exports.deleteMetaOptionsValue = exports.setRadioValue = exports.updateMetaOptionsValue = exports.setMetaOptionsValue = exports.validateStepSuccess = exports.validateStepFailure = exports.changeStep = exports.fetchCustomersFailed = exports.fetchCustomersSuccess = exports.fetchCustomers = exports.closeMetaModal = exports.toggleEdit = exports.toggleCreate = exports.clearState = exports.setSelectedValue = exports.deleteMetaElementFailed = exports.deleteMetaElementSuccess = exports.deleteMetaElement = exports.moveMetaFailed = exports.moveMetaSuccess = exports.moveMetaElement = exports.addMetaElement = exports.updateWizardStep = exports.setMetaField = exports.updateField = exports.UsergroupInvite = exports.UsergroupList = void 0;
exports.step1Features = exports.step5 = exports.updateWizardCustomer = exports.getSalesRepresentiveFailure = exports.getSalesRepresentiveSuccess = exports.getSalesRepresentiveRequest = exports.fetchMetasFailed = exports.fetchMetasSuccess = exports.fetchMetas = exports.insertMetaFailed = exports.insertMetaSuccess = exports.insertMetaValidation = exports.insertMeta = exports.removeUserFromGroupFailed = exports.removeUserFromGroupSuccess = exports.removeUserFromGroup = exports.toggleModal = exports.deleteEditSetName = exports.deleteEditUserGroupFailed = exports.deleteEditUserGroupSuccess = exports.deleteEditUserGroupRequest = exports.deleteEditCategoryFailed = exports.deleteEditCategorySuccess = exports.deleteEditCategoryRequest = void 0;
const ActionTypes = require("../../actionTypes/project/wizard");
require("./wizardSteps");
const step5Actions = require("./wizardSteps/step5");
const step1_features = require("./wizardSteps/step1_features");
const _usergroupInvite = require("../../modules/usergroup/invite/actions");
const _usergroupList = require("../../modules/usergroup/list/actions");
exports.UsergroupList = _usergroupList.default('project/wizard');
exports.UsergroupInvite = _usergroupInvite.default('project/wizard');
const updateField = (key, value) => ({
    type: ActionTypes.UPDATE_FIELD,
    payload: {
        key,
        value
    }
});
exports.updateField = updateField;
const setMetaField = (key, value) => ({
    type: ActionTypes.SET_META_FIELD,
    payload: {
        key,
        value
    }
});
exports.setMetaField = setMetaField;
function updateWizardStep(step) {
    return {
        type: ActionTypes.UPDATE_WIZARD_STEP,
        payload: {
            step
        }
    };
}
exports.updateWizardStep = updateWizardStep;
//#region CREATE META
const addMetaElement = (schemaId, meta) => ({
    type: ActionTypes.ADD_META_ELEMENT,
    payload: {
        schemaId,
        meta
    }
});
exports.addMetaElement = addMetaElement;
const moveMetaElement = (schemaId, meta) => ({
    type: ActionTypes.MOVE_META,
    payload: {
        schemaId,
        meta
    }
});
exports.moveMetaElement = moveMetaElement;
const moveMetaSuccess = () => ({
    type: ActionTypes.MOVE_META_SUCCESS
});
exports.moveMetaSuccess = moveMetaSuccess;
const moveMetaFailed = (error) => ({
    type: ActionTypes.MOVE_META_FAILED,
    payload: error
});
exports.moveMetaFailed = moveMetaFailed;
const deleteMetaElement = (schemaId, uuid) => ({
    type: ActionTypes.DELETE_META_ELEMENT,
    payload: {
        schemaId,
        uuid
    }
});
exports.deleteMetaElement = deleteMetaElement;
const deleteMetaElementSuccess = (uuid) => ({
    type: ActionTypes.DELETE_META_ELEMENT_SUCCESS,
    payload: {
        uuid
    }
});
exports.deleteMetaElementSuccess = deleteMetaElementSuccess;
const deleteMetaElementFailed = (error) => ({
    type: ActionTypes.DELETE_META_ELEMENT_FAILED,
    payload: error
});
exports.deleteMetaElementFailed = deleteMetaElementFailed;
const setSelectedValue = (value) => ({
    type: ActionTypes.SET_SELECTED_VALUE,
    payload: {
        value
    }
});
exports.setSelectedValue = setSelectedValue;
const clearState = () => ({
    type: ActionTypes.CLEAR_STATE
});
exports.clearState = clearState;
const toggleCreate = () => ({
    type: ActionTypes.TOGGLE_CREATE
});
exports.toggleCreate = toggleCreate;
const toggleEdit = (uuid) => ({
    type: ActionTypes.TOGGLE_EDIT,
    payload: {
        uuid
    }
});
exports.toggleEdit = toggleEdit;
const closeMetaModal = () => ({
    type: ActionTypes.CLOSE_META_MODAL
});
exports.closeMetaModal = closeMetaModal;
const fetchCustomers = (name) => ({
    type: ActionTypes.FETCH_CUSTOMERS,
    payload: {
        name
    }
});
exports.fetchCustomers = fetchCustomers;
const fetchCustomersSuccess = (customers) => ({
    type: ActionTypes.FETCH_CUSTOMERS_SUCCESS,
    payload: {
        customers
    }
});
exports.fetchCustomersSuccess = fetchCustomersSuccess;
function fetchCustomersFailed(error) {
    return {
        type: ActionTypes.FETCH_CUSTOMERS_FAILED,
        payload: error
    };
}
exports.fetchCustomersFailed = fetchCustomersFailed;
function changeStep(wizardStep) {
    return {
        type: ActionTypes.CHANGE_STEP,
        payload: {
            wizardStep
        }
    };
}
exports.changeStep = changeStep;
const validateStepFailure = (errors) => ({
    type: ActionTypes.VALIDATE_STEP_FAILURE,
    payload: {
        errors
    }
});
exports.validateStepFailure = validateStepFailure;
const validateStepSuccess = (wizardStep) => ({
    type: ActionTypes.VALIDATE_STEP_SUCCESS,
    payload: {
        wizardStep
    }
});
exports.validateStepSuccess = validateStepSuccess;
const setMetaOptionsValue = (value, parent) => ({
    type: ActionTypes.SET_META_OPTIONS_VALUE,
    payload: {
        value,
        parent
    }
});
exports.setMetaOptionsValue = setMetaOptionsValue;
const updateMetaOptionsValue = (value, parent) => ({
    type: ActionTypes.UPDATE_META_OPTIONS_VALUE,
    payload: {
        value,
        parent
    }
});
exports.updateMetaOptionsValue = updateMetaOptionsValue;
const setRadioValue = (value) => ({
    type: ActionTypes.SET_RADIO_VALUE,
    payload: {
        value
    }
});
exports.setRadioValue = setRadioValue;
const deleteMetaOptionsValue = (value, parent) => ({
    type: ActionTypes.DELETE_META_OPTIONS_VALUE,
    payload: {
        value,
        parent
    }
});
exports.deleteMetaOptionsValue = deleteMetaOptionsValue;
const createProject = (state) => ({
    type: ActionTypes.CREATE_PROJECT,
    payload: state
});
exports.createProject = createProject;
const createProjectSuccess = (project) => ({
    type: ActionTypes.CREATE_PROJECT_SUCCESS,
    payload: {
        project
    }
});
exports.createProjectSuccess = createProjectSuccess;
const createProjectFailed = (error) => ({
    type: ActionTypes.CREATE_PROJECT_FAILED,
    payload: error
});
exports.createProjectFailed = createProjectFailed;
const fetchPrintProviderRequest = () => ({
    type: ActionTypes.FETCH_PRINT_PROVIDER_REQUEST
});
exports.fetchPrintProviderRequest = fetchPrintProviderRequest;
const fetchPrintProviderSuccess = (providers) => ({
    type: ActionTypes.FETCH_PRINT_PROVIDER_SUCCESS,
    payload: providers
});
exports.fetchPrintProviderSuccess = fetchPrintProviderSuccess;
//#region billing information
const toggleBillingInformationModal = () => ({
    type: ActionTypes.TOGGLE_BILLING_INFORMATION_MODAL
});
exports.toggleBillingInformationModal = toggleBillingInformationModal;
const removeBillingInformationCustomer = (customer) => ({
    type: ActionTypes.REMOVE_BILLING_INFORMATION_CUSTOMER,
    payload: customer
});
exports.removeBillingInformationCustomer = removeBillingInformationCustomer;
const toggleEditBillingInformationModal = (customer) => ({
    type: ActionTypes.TOGGLE_EDIT_BILLING_INFORMATION_MODAL,
    payload: customer
});
exports.toggleEditBillingInformationModal = toggleEditBillingInformationModal;
const fetchPrintProviderFailure = (error) => ({
    type: ActionTypes.FETCH_PRINT_PROVIDER_FAILURE,
    payload: error
});
exports.fetchPrintProviderFailure = fetchPrintProviderFailure;
const searchBillingInformationRequest = (params) => ({
    type: ActionTypes.SEARCH_BILLING_INFORMATION_REQUEST,
    payload: params
});
exports.searchBillingInformationRequest = searchBillingInformationRequest;
const searchBillingInformationFailed = (searchType, error) => ({
    type: ActionTypes.SEARCH_BILLING_INFORMATION_FAILED,
    searchType,
    payload: error
});
exports.searchBillingInformationFailed = searchBillingInformationFailed;
const searchBillingInformationSuccess = (type, list) => ({
    type: ActionTypes.SEARCH_BILLING_INFORMATION_SUCCESS,
    payload: {
        type,
        list
    }
});
exports.searchBillingInformationSuccess = searchBillingInformationSuccess;
const selectBillingInformationCustomer = (customer) => ({
    type: ActionTypes.SELECT_BILLING_INFORMATION_CUSTOMER,
    payload: customer
});
exports.selectBillingInformationCustomer = selectBillingInformationCustomer;
const selectBillingInformationProject = (projects) => ({
    type: ActionTypes.SELECT_BILLING_INFORMATION_PROJECT,
    payload: projects
});
exports.selectBillingInformationProject = selectBillingInformationProject;
const setBillingInformations = (customer) => ({
    type: ActionTypes.SET_BILLING_INFORMATIONS,
    payload: customer
});
exports.setBillingInformations = setBillingInformations;
const clearBillingInformationModal = () => ({
    type: ActionTypes.CLEAR_BILLING_INFORMATION_MODAL
});
exports.clearBillingInformationModal = clearBillingInformationModal;
//#endregion
const saveStep = (state) => ({
    type: ActionTypes.SAVE_STEP,
    payload: {
        state
    }
});
exports.saveStep = saveStep;
const saveStepFailure = (error) => ({
    type: ActionTypes.SAVE_STEP_FAILURE,
    payload: error
});
exports.saveStepFailure = saveStepFailure;
const saveStepSuccess = (id) => ({
    type: ActionTypes.SAVE_STEP_SUCCESS,
    payload: {
        id
    }
});
exports.saveStepSuccess = saveStepSuccess;
const modifyProjectRequest = (id) => ({
    type: ActionTypes.MODIFY_PROJECT_REQUEST,
    payload: {
        id
    }
});
exports.modifyProjectRequest = modifyProjectRequest;
const modifyProjectFailure = (error) => ({
    type: ActionTypes.MODIFY_PROJECT_FAILURE,
    payload: error
});
exports.modifyProjectFailure = modifyProjectFailure;
const setModifyProject = (project) => ({
    type: ActionTypes.SET_MODIFY_PROJECT,
    payload: {
        project
    }
});
exports.setModifyProject = setModifyProject;
const deleteEdit = (mode, type, name, id) => ({
    type: ActionTypes.DELETE_EDIT,
    payload: {
        mode,
        name,
        id,
        type
    }
});
exports.deleteEdit = deleteEdit;
function deleteEditCategoryRequest(mode, name, id) {
    return {
        type: ActionTypes.DELETE_EDIT_CATEGORY_REQUEST,
        payload: {
            mode,
            name,
            id
        }
    };
}
exports.deleteEditCategoryRequest = deleteEditCategoryRequest;
const deleteEditCategorySuccess = () => ({
    type: ActionTypes.DELETE_EDIT_CATEGORY_SUCCESS
});
exports.deleteEditCategorySuccess = deleteEditCategorySuccess;
const deleteEditCategoryFailed = (error) => ({
    type: ActionTypes.DELETE_EDIT_CATEGORY_FAILED,
    payload: error
});
exports.deleteEditCategoryFailed = deleteEditCategoryFailed;
function deleteEditUserGroupRequest(mode, name, id) {
    return {
        type: ActionTypes.DELETE_EDIT_USER_GROUP_REQUEST,
        payload: {
            mode,
            name,
            id
        }
    };
}
exports.deleteEditUserGroupRequest = deleteEditUserGroupRequest;
const deleteEditUserGroupSuccess = () => ({
    type: ActionTypes.DELETE_EDIT_USER_GROUP_SUCCESS
});
exports.deleteEditUserGroupSuccess = deleteEditUserGroupSuccess;
const deleteEditUserGroupFailed = (error) => ({
    type: ActionTypes.DELETE_EDIT_USER_GROUP_FAILED,
    payload: error
});
exports.deleteEditUserGroupFailed = deleteEditUserGroupFailed;
const deleteEditSetName = (name) => ({
    type: ActionTypes.DELETE_EDIT_SET_NAME,
    payload: name
});
exports.deleteEditSetName = deleteEditSetName;
const toggleModal = () => ({
    type: ActionTypes.TOGGLE_MODAL
});
exports.toggleModal = toggleModal;
const removeUserFromGroup = (userId, groupId) => ({
    type: ActionTypes.REMOVE_USER_FROM_GROUP,
    payload: {
        userId,
        groupId
    }
});
exports.removeUserFromGroup = removeUserFromGroup;
const removeUserFromGroupSuccess = () => ({
    type: ActionTypes.REMOVE_USER_FROM_GROUP_SUCCESS
});
exports.removeUserFromGroupSuccess = removeUserFromGroupSuccess;
const removeUserFromGroupFailed = (error) => ({
    type: ActionTypes.REMOVE_USER_FROM_GROUP_FAILED,
    payload: error
});
exports.removeUserFromGroupFailed = removeUserFromGroupFailed;
const insertMeta = (meta) => ({
    type: ActionTypes.INSERT_META,
    payload: {
        meta
    }
});
exports.insertMeta = insertMeta;
const insertMetaValidation = (error) => ({
    type: ActionTypes.INSERT_META_VALIDATION,
    payload: error
});
exports.insertMetaValidation = insertMetaValidation;
const insertMetaSuccess = () => ({
    type: ActionTypes.INSERT_META_SUCCESS
});
exports.insertMetaSuccess = insertMetaSuccess;
const insertMetaFailed = (error) => ({
    type: ActionTypes.INSERT_META_FAILED,
    payload: error
});
exports.insertMetaFailed = insertMetaFailed;
const fetchMetas = (projectId) => ({
    type: ActionTypes.FETCH_METAS,
    payload: {
        projectId
    }
});
exports.fetchMetas = fetchMetas;
const fetchMetasSuccess = (metas) => ({
    type: ActionTypes.FETCH_METAS_SUCCESS,
    payload: metas
});
exports.fetchMetasSuccess = fetchMetasSuccess;
const fetchMetasFailed = (error) => ({
    type: ActionTypes.FETCH_METAS_FAILED,
    payload: error
});
exports.fetchMetasFailed = fetchMetasFailed;
const getSalesRepresentiveRequest = (customerId) => ({
    type: ActionTypes.GET_SALES_REPRESENTIVE_REQUEST,
    payload: customerId
});
exports.getSalesRepresentiveRequest = getSalesRepresentiveRequest;
const getSalesRepresentiveSuccess = (user) => ({
    type: ActionTypes.GET_SALES_REPRESENTIVE_SUCCESS,
    payload: user
});
exports.getSalesRepresentiveSuccess = getSalesRepresentiveSuccess;
const getSalesRepresentiveFailure = (error) => ({
    type: ActionTypes.GET_SALES_REPRESENTIVE_FAILURE,
    payload: error
});
exports.getSalesRepresentiveFailure = getSalesRepresentiveFailure;
const updateWizardCustomer = (customer) => ({
    type: ActionTypes.UPDATE_WIZARD_CUSTOMER,
    payload: {
        customer
    }
});
exports.updateWizardCustomer = updateWizardCustomer;
exports.step5 = step5Actions;
exports.step1Features = step1_features;
//# sourceMappingURL=wizard.js.map